<template>
    <div>
        <div class="btn-group btn-group-sm" ref="button">
            <button type="button" class="btn btn-success" @click="openPending(__('bets.Win Bet'), (profit || 0))">
                <i class="fas fa-check" data-toggle="tooltip" data-placement="top" :title="__('bets.Win Bet')"></i>
            </button>
            <button type="button" class="btn btn-danger" @click="openPending(__('bets.Lost Bet'), (bet.stake * -1))">
                <i class="fas fa-minus" data-toggle="tooltip" data-placement="top" :title="__('bets.Lost Bet')"></i>
            </button>
            <button type="button" class="btn btn-secondary" @click="openPending(__('bets.Draw Bet'), 0)">
                <i class="fas fa-equals" data-toggle="tooltip" data-placement="top" :title="__('bets.Draw Bet')"></i>
            </button>
        </div>

        <b-modal
            :id="betId"
            :title="title"
            size="sm"
            hide-header
            hide-footer
            centered>

            <div class="form-group">

                <label>
                    {{ __('bets.Result') }}
                </label>

                <currency-input
                    :locale="locale"
                    :currency='currency'
                    class="form-control font-weight-bold"
                    v-bind:class="{'text-muted': form.result == 0, 'text-success': form.result > 0, 'text-danger': form.result < 0}"
                    v-model="form.result"
                />

            </div>

            <div class="form-group mb-0">
                <button type="button" class="btn btn-primary" @click="save" :disabled="loading">
                    <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="loading"></span>
                    <span v-if="!form.busy">{{ __('bets.Update Result') }}</span>
                    <span v-if="form.busy">{{ __('bets.Saving') }} ...</span>
                </button>
            </div>

        </b-modal>

    </div>
</template>

<script>
export default {
    props: ['bet', 'profit', 'locale', 'currency'],
    data() {
        return {
            loading: false,
            title: this.__('bets.Win Bet'),
            form: {
                result: null
            }
        }
    },
    computed: {
        betId() {
            return 'betPendingModal' + this.bet.id;
        }
    },
    methods: {
        openPending(title, value) {
            this.title = title;
            this.form.result = value;
            this.$bvModal.show(this.betId)
        },
        save() {
            this.loading = true;
            axios.put('/bets/' + this.bet.id + '/update/pending', this.form)
                .then(result => {
                    if (result.redirect) {
                        window.location = result.redirect
                    } else {
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                })
        }
    }
}
</script>

<style scoped>

</style>
